<script>
import AbstractDateInput from "@/components/General/Form/Date/Abstract/AbstractDateInput";

export default {
    extends: AbstractDateInput,
    props:{
        inputType: {
            type: String,
            default: "date",
        },
    },
    data() {
        return {
            min: new Date().toISOString().substr(0, 10),
            type: this.inputType,
        }
    }
}
</script>
